module.exports = __webpack_public_path__ + "static/media/eclipse.5261bb7a.jpg";